/**
 * Componente SkipLinks
 * 
 * Links de navegação rápida para acessibilidade.
 * Permite que usuários de leitores de tela e navegação por teclado
 * pulem para seções principais da página.
 * 
 * @module components/Common/SkipLinks
 */

import React from 'react';
import { FaChartLine, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';

/**
 * Componente de Skip Links
 * 
 * Renderiza links invisíveis que aparecem quando focados,
 * permitindo navegação rápida para seções principais.
 * 
 * @returns {JSX.Element} Componente de skip links
 */
const SkipLinks = () => {
    const skipLinks = [
        {
            id: 'skip-to-kpis',
            href: '#kpi-section',
            label: 'Pular para métricas principais',
            icon: FaChartLine,
        },
        {
            id: 'skip-to-charts',
            href: '#charts-section',
            label: 'Pular para gráficos',
            icon: FaChartLine,
        },
        {
            id: 'skip-to-alerts',
            href: '#alerts-section',
            label: 'Pular para alertas',
            icon: FaExclamationTriangle,
        },
        {
            id: 'skip-to-main',
            href: '#dashboard-page',
            label: 'Pular para conteúdo principal',
            icon: FaInfoCircle,
        },
    ];

    return (
        <nav 
            className="absolute top-0 left-0 z-50" 
            aria-label="Links de navegação rápida"
        >
            <ul className="sr-only focus-within:not-sr-only flex flex-col gap-2 p-4 bg-white shadow-lg rounded-lg border border-gray-200">
                {skipLinks.map((link) => {
                    const Icon = link.icon;
                    return (
                        <li key={link.id}>
                            <a
                                href={link.href}
                                id={link.id}
                                className="
                                    flex items-center gap-2
                                    px-4 py-2
                                    text-sm font-semibold
                                    text-gray-700
                                    bg-emerald-50
                                    border border-emerald-200
                                    rounded-lg
                                    hover:bg-emerald-100
                                    hover:border-emerald-300
                                    focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2
                                    transition-colors duration-200
                                "
                                aria-label={link.label}
                            >
                                <Icon 
                                    className="text-emerald-600" 
                                    size={14}
                                    aria-hidden="true"
                                />
                                <span>{link.label}</span>
                            </a>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default SkipLinks;

